module.exports = __webpack_public_path__ + "static/media/error-icon.2389ba47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/Images/error-icon.svg
// module id = 550
// module chunks = 2